// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_uZX3Z","text":"text_svs16"};